module.exports = {"TXTWCL_Total_spinsX_N0":{"id":"TXTWCL_Total_spinsX_N0","defaultMessage":"Összes pörgetés: {0}"}}